(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
  }
  connectedCallback() {
    this.header = this.closest('.section-header');
    if (!this.header) return;
    this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
    this.resizeObserver.observe(this.header);
    this.currentScrollTop = window.pageYOffset;
    this.preventReveal = false;
    this.predictiveSearches = this.querySelectorAll('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.createObserver();
    this.escapeHandler = (event) => {
      if (event.key === 'Escape') {
        this.querySelectorAll('.zerivo-header-nav details[open]').forEach((details) => {
          details.open = false;
          details.querySelector('summary')?.focus();
        });
      }
    };
    this.addEventListener('keydown', this.escapeHandler);
  }
  setHeaderHeight() {
    if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.mobileMediaQuery?.removeEventListener('change', this.setHeaderHeight);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this.removeEventListener('keydown', this.escapeHandler);
    window.removeEventListener('scroll', this.onScrollHandler);
    this.resizeObserver?.disconnect();
    this.intersectionObserver?.disconnect();
    window.clearTimeout(this.isScrolling);
  }
  createObserver() {
    this.intersectionObserver = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    this.intersectionObserver.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if ([...this.predictiveSearches].some((search) => search.isOpen)) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(() => this.hide());
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) requestAnimationFrame(() => this.reveal());
      else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(() => this.hide());
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(() => this.reset());
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.querySelectorAll('header-menu').forEach((menu) => menu.close());
    this.querySelectorAll('details-modal').forEach((modal) => modal.close(false));
    this.querySelectorAll('.zerivo-header-nav details[open]').forEach((details) => { details.open = false; });
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}
if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);
if (!window.zerivoAccountAnchorReady) {
  window.zerivoAccountAnchorReady = true;
  document.addEventListener('open', (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
    const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
    event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
  }, true);
}

  } catch(e) { console.error(e); }
})();
})();
